/* eslint-disable max-len */

/* eslint-disable max-params */

/**
 * An object event a.k.a. notification.
 *
 * @property {boolean}                  acknowledged            - Indicates whether an event has been acknowledged.
 * @property {ObjectEventResolution}    [acknowledgement]       - Information about event acknowledgement. Only present when event is acknowledged.
 * @property {string}                   [addressId]             - ID of the related address that matches the position of this event. Is not set when no address matches.
 * @property {string[]}                 [controlFlags]          - Flags which indicate what actions are possible with the event. User rights and current status of an event can affect the flags. Possible flags are: 'resolveEvent', 'acknowledgeEvent'.
 * @property {string}                   currentEventLevel       - Current event level. An event with alarm level will become a warning when acknowledged. So the currentEventLevel can be different from the originalEventLevel. = ['MESSAGE', 'NOTICE', 'WARNING', 'ALARM1', 'ALARM2', 'ALARM3'].
 * @property {string}                   eventId                 - ID of the event.
 * @property {EventMessage}             [eventMessage]          - Event message.
 * @property {string}                   eventTime               - Time of the event creation.
 * @property {string}                   [lastModified]          - Latest time of the 3 times (event, resolve and acknowledge).
 * @property {string}                   objectId                - ID of the object for this event.
 * @property {string}                   originalEventLevel      - Original event level = ['MESSAGE', 'NOTICE', 'WARNING', 'ALARM1', 'ALARM2', 'ALARM3'].
 * @property {Position}                 [position]              - Posion of the object when the event ocuurred.
 * @property {string}                   [positionTime]          - The time that is related to the last known position of the vehicle when the event occurred.
 * @property {number}                   [repeatCount]           - The repeat counter for repeated events. Repeated events are accumulated events of the same type which occurred shortly after each other. E.g. movement inside an area.
 * @property {ObjectEventResolution}    [resolution]            - Information about event resolving. Only present when event is resolved.
 * @property {boolean}                  resolved                - Indicates whether an event has been resolved.
 */
export class ObjectEvent {
    /**
     * Creates a ObjectEvent.
     *
     * @param {string} eventId              - ID of the event.
     * @param {string} objectId             - ID of the object for this event.
     * @param {string} eventTime            - Time of the event creation.
     * @param {string} originalEventLevel   - Original event level = ['MESSAGE', 'NOTICE', 'WARNING', 'ALARM1', 'ALARM2', 'ALARM3'].
     * @param {string} currentEventLevel    - Current event level. An event with alarm level will become a warning originalEventLevel. ['MESSAGE', 'NOTICE', 'WARNING', 'ALARM1', 'ALARM2', 'ALARM3'].
     * @param {boolean} acknowledged        - Indicates whether an event has been acknowledged.
     * @param {boolean} resolved            - Indicates whether an event has been resolved.
     */
    constructor(eventId, objectId, eventTime, originalEventLevel, currentEventLevel, acknowledged, resolved) {
        this.eventId = eventId
        this.objectId = objectId
        this.eventTime = eventTime
        this.acknowledged = acknowledged
        this.originalEventLevel = originalEventLevel
        this.currentEventLevel = currentEventLevel
        this.resolved = resolved
        this.position = null
        this.positionTime = null
        this.repeatCount = null
        this.resolution = null
        this.acknowledgement = null
        this.addressId = null
        this.controlFlags = null
        this.eventMessage = null
        this.lastModified = null
    }
}

/* eslint-enable max-params */
/* eslint-enable max-len */
